import { useIntl } from 'react-intl';

import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { PaidHeroTabPanelTemplate } from './hero-tab-panel-template';

const SoftwareTabContent = () => {
	const intl = useIntl();

	const gwp9473JSWAnchorUpdates = checkFeatureFlagGate(featureFlags.gwp9473JSWAnchorUpdates);

	const softwareHeroProps = {
		header: intl.formatMessage({
			id: 'JiraSoftwarePagePaidLpJswFeatures.hero.software.header',
			defaultMessage: 'Jira is the #1 software development tool used by agile teams',
		}),
		image: {
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fya3j34w81idu648i580m4mutc60guo0.webp',
			alt: intl.formatMessage({
				id: 'JiraSoftwarePagePaidLpJswFeatures.software.heroImageAlt',
				defaultMessage: 'Screen capture of a Jira board',
			}),
		},
	};

	const gwp9473JSWAnchorUpdatesHeroProps = {
		header: intl.formatMessage({
			id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.software.header',
			defaultMessage: 'Focus on outcomes, not admin',
		}),
		image: {
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3m35263c8gy137p68p2v33ijxb0703p5.webp',
			alt: intl.formatMessage({
				id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.software.heroImageAlt',
				defaultMessage: 'Screenshot of Jira list view',
			}),
		},
	};

	return (
		<PaidHeroTabPanelTemplate
			{...(gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : softwareHeroProps)}
		/>
	);
};

export default SoftwareTabContent;
